// extracted by mini-css-extract-plugin
export default {"form":"styles_form__3OBPo","buttonBack":"styles_buttonBack__j2mgZ"};